// extracted by mini-css-extract-plugin
module.exports = {"editDocumentWindowFooter":"editDocumentWindowFooter__eHyF2"};